import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TimeFromNow from "./TimeFromNow";

const ActivityItem = ({activity, ...rest}) => {
	let avatarClasses = 'bg-success text-white';
	let avatarIcon = <i className="fa fa-list-ul"/>;
	if (activity.type === 'Sent PDF') {
		avatarClasses = 'bg-gray text-white';
		avatarIcon = <i className="fa fa-envelope"/>;
	} else if (activity.type === 'Hour Lock') {
		avatarClasses = 'bg-info text-white';
		avatarIcon = activity.value === 'Lock'
			? <i className="fa fa-lock"/>
			: <i className="fa fa-unlock"/>;
	} else if (activity.type === 'Login') {
		avatarClasses = 'bg-info text-white';
		avatarIcon = <i className="fa fa-sign-in"/>;
	} else if (activity.type === 'Logout') {
		avatarClasses = 'bg-danger text-white';
		avatarIcon = <i className="fa fa-sign-out"/>;
	}

	return  <div>
		<div className="media activity-media" {...rest}>
			<span className={`avatar ${avatarClasses}`}>
				{avatarIcon}
			</span>
			<div className="media-body">
				<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
					<h5 className='activity-title text-primary text-bold'>{activity.type} {" "} {activity.value ? <span className='text-normal'>({activity.value})</span> : ''}</h5>
					<div>
						<TimeFromNow date={activity.created_at} suffix={false}/>
					</div>
				</div>
				<p className='fs--0 text-muted text-bold'>{activity.message}</p>
				<p className='text-semi-bold margin-bottom-none'>
					{(activity.creator) &&
						<span style={{marginRight: '20px'}}>By <span className="text-primary">{activity.creator.name}</span></span>
					}
					<span>Device IP: <span className="text-primary">{activity.ip_address}</span></span>
				</p>
			</div>
		</div>
	</div>
};
ActivityItem.propTypes = {
	activity: PropTypes.object.isRequired
};

const ActivityEndNotice = ({message, className, ...rest}) => (
	<p className={`text-gray margin-bottom-none ${className}`} {...rest}>
		{message}
	</p>
);
ActivityEndNotice.propTypes = {
	message: PropTypes.string,
	className: PropTypes.string
};
ActivityEndNotice.defaultProps = {
	message: "No more activities left. You are almost end!"
}

class Activity extends Component {
	static Item = ActivityItem;
	static EndNotice = ActivityEndNotice;

	render() {
		const {children, ...rest} = this.props;

		return (
			<div {...rest}>
				{children}
			</div>
		);
	}
}

Activity.propTypes = {};

export default Activity;
